var CartSummary = {
  codes(current, added, removed) {
    const values = (current || []).map(x => x.code).filter(Boolean).filter(x => !removed || x.toLowerCase() !== removed.toLowerCase());
    if (added && added.trim()) values.push(added.trim());
    return values.filter((x, i) => values.findIndex(y => y.toLowerCase() === x.toLowerCase()) === i);
  },
  async update(fetcher, root, section, added, removed) {
    if (!removed && (!added || !added.trim() || added.includes(','))) throw new Error('empty');
    const before = await fetcher(root + 'cart.js');
    if (!before.ok) throw new Error('network');
    const cart = await before.json();
    const response = await fetcher(root + 'cart/update.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({discount:this.codes(cart.discount_codes, added, removed).join(','), sections:[section], sections_url:location.pathname})});
    if (!response.ok) throw new Error('network');
    const updated = await response.json();
    return {cart:updated, valid:removed ? true : !!updated.discount_codes?.some(x => x.code.toLowerCase() === added.trim().toLowerCase() && x.applicable)};
  }
};
if (typeof document !== 'undefined') {
  customElements.define('cart-summary-note', class extends HTMLElement {
    connectedCallback() {
      this.querySelector('textarea').addEventListener('change', async () => {
        const input = this.querySelector('textarea'), status = this.querySelector('[role=status]');
        input.disabled = true; status.textContent = this.dataset.loading;
        try {
          const response = await fetch(Shopify.routes.root + 'cart/update.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({note:input.value})});
          if (!response.ok) throw new Error('network');
          const cart = await response.json();
          if (cart.note !== input.value) throw new Error('network');
          status.textContent = this.dataset.success;
        } catch(error) { status.textContent = this.dataset.error; }
        finally { input.disabled = false; }
      });
    }
  });
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-summary-apply], [data-summary-remove]');
    if (!button) return;
    let control = button.closest('.cart-summary-code');
    const main = document.querySelector('main-cart');
    if (main.dataset.summaryBusy || main.classList.contains('cart-update')) return;
    main.dataset.summaryBusy = 'true';
    let input = control.querySelector('input');
    let status = control.querySelector('[role=status]');
    const wasOpen = control.open, entered = input.value;
    const blocks = [...main.querySelectorAll('.cart-content-items,.cart-recommendations,.cart__gift-wrap,cart-summary-note,.cart__dynamic-checkout-buttons,form:has([name=checkout])')];
    const checkoutButtons = [...main.querySelectorAll('[name=checkout]')].map(element => ({element, disabled:element.disabled}));
    checkoutButtons.forEach(({element}) => element.disabled = true);
    blocks.forEach(x => x.inert = true);
    control.dataset.busy = 'true';
    control.querySelectorAll('button').forEach(x => x.disabled = true);
    status.textContent = control.dataset.loading;
    try {
      const section = document.querySelector('main-cart').dataset.sectionId;
      const result = await CartSummary.update(fetch, Shopify.routes.root, section, button.hasAttribute('data-summary-apply') ? input.value : null, button.dataset.summaryRemove);
      let html = result.cart.sections?.[section];
      if (!html) {
        const response = await fetch(location.pathname + '?section_id=' + encodeURIComponent(section));
        if (!response.ok) throw new Error('network');
        html = await response.text();
      }
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      if (!parsed.querySelector('.main-cart-totals .cart-summary-code')) throw new Error('network');
      for (const selector of ['.main-cart-totals', '.cart-content-items', '.checkout__sticky__wrapper', '.free-shipping-bar', '.cart-summary-codes', '.cart-recommendations']) {
        const source = parsed.querySelector(selector), target = document.querySelector('main-cart ' + selector);
        if (source && target) target.innerHTML = source.innerHTML;
      }
      control = main.querySelector('.cart-summary-code');
      input = control.querySelector('input');
      status = control.querySelector('[role=status]');
      control.open = wasOpen;
      input.value = entered;
      status.textContent = result.valid ? control.dataset.success : control.dataset.invalid;
      if (result.valid) input.value = '';
      input.focus({preventScroll:true});
    } catch(error) {
      status.textContent = error.message === 'empty' ? control.dataset.empty : control.dataset.error;
    } finally {
      delete control.dataset.busy;
      delete main.dataset.summaryBusy;
      blocks.forEach(x => x.inert = false);
      checkoutButtons.forEach(({element, disabled}) => element.disabled = disabled);
      main.querySelectorAll('.cart-content-items,.cart-recommendations,.cart__gift-wrap,cart-summary-note,.cart__dynamic-checkout-buttons,form:has([name=checkout])').forEach(x => x.inert = false);
      control.querySelectorAll('button').forEach(x => x.disabled = false);
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Enter' && event.target.matches('.cart-summary-code input')) {
      event.preventDefault(); event.target.closest('.cart-summary-code').querySelector('[data-summary-apply]').click();
    }
  });
}
